<template>
  <edit-profile/>
</template>

<script>
import editProfile from '../../../components/user-profile/edit-profile'
export default {
  name: 'EditProfileView',
  components: {
    editProfile
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/edit-profile.view.vue